import Cookies from "js-cookie";

const topicForm = document.getElementById("topicForm");
if (topicForm) {
  topicForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const checkboxes = topicForm.querySelectorAll('input[type="checkbox"]:checked');
    const selectedTopics = Array.from(checkboxes).map((checkbox) => checkbox.value);
    window.location.href = "/result/?topics=" + selectedTopics.join(":");
  });
}

const topicBrowserTabs = document.querySelector(".topicBrowser-tabs");
const tabs = document.querySelectorAll('[role="tab"]') as NodeListOf<HTMLButtonElement>;
const panels = document.querySelectorAll('[role="tabpanel"]');

function toggleTab(currentTab: HTMLButtonElement, currentPanel: HTMLElement) {
  const isActive = currentTab.getAttribute("aria-selected") === "true";

  // Hide all panels
  panels.forEach((panel) => {
    panel.classList.remove("is-visible");
    // clean the selected subtopics on tab change
    const checkboxes = panel.querySelectorAll(
      'input[type="checkbox"]:checked'
    ) as NodeListOf<HTMLInputElement>;
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    const button = panel.querySelector("button");
    if (button) {
      button.classList.remove("has-subtopics");
    }
  });

  // Deselect all tabs
  tabs.forEach((tab) => {
    tab.setAttribute("aria-selected", "false");
    tab.setAttribute("tabindex", "-1");
  });

  if (isActive) {
    // Hide the clicked tab
    currentTab.setAttribute("aria-selected", "false");
    currentTab.setAttribute("tabindex", "-1");

    // Set the first tab panel as active
    const firstPanel = panels[0];
    firstPanel.classList.add("is-visible");
    topicBrowserTabs?.classList.add("is-init");
  } else {
    // Activate the clicked tab
    currentTab.setAttribute("aria-selected", "true");
    currentTab.setAttribute("tabindex", "0");

    // Show the associated panel
    currentPanel.classList.add("is-visible");
  }
}

if (tabs.length && panels.length) {
  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();

      if (topicBrowserTabs?.classList.contains("is-init")) {
        topicBrowserTabs.classList.remove("is-init");
      }

      // Get the associated panel
      const panelId = tab.getAttribute("aria-controls");
      const panel = panelId && document.getElementById(panelId);

      if (panel) {
        toggleTab(tab, panel);
      }
    });

    // keyboard navigation
    tab.addEventListener("keydown", (e: Event) => {
      e.preventDefault();

      const key = (e as KeyboardEvent).key;
      const currentIndex = Array.from(tabs).indexOf(tab);
      let nextIndex = currentIndex;

      if (key === "ArrowRight" || key === "ArrowDown") {
        nextIndex = currentIndex + 1;
      } else if (key === "ArrowLeft" || key === "ArrowUp") {
        nextIndex = currentIndex - 1;
      }

      if (nextIndex < 0) {
        nextIndex = tabs.length - 1;
      } else if (nextIndex >= tabs.length) {
        nextIndex = 0;
      }

      if (nextIndex !== currentIndex) {
        tabs[nextIndex].focus();
      }

      // Activate the tab when Enter or Space is pressed
      if (key === "Enter" || key === " ") {
        tabs[currentIndex].click();
      }

      // Focus the first checkbox in the panel when tab is pressed
      if (key === "Tab") {
        const panelId = tab.getAttribute("aria-controls");
        if (panelId) {
          const panel = document.getElementById(panelId);
          if (panel) {
            const firstCheckbox = panel.querySelector('input[type="checkbox"]') as HTMLInputElement;
            if (firstCheckbox) {
              firstCheckbox.focus();
            }
          }
        }
      }
    });
  });
}

if (panels.length > 0) {
  panels.forEach((panel) => {
    const checkboxes = panel.querySelectorAll(
      'input[type="checkbox"]'
    ) as NodeListOf<HTMLInputElement>;
    const button = panel.querySelector("button");
    if (button) {
      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", (e) => {
          const selectedCheckboxes = panel.querySelectorAll('input[type="checkbox"]:checked');
          if (selectedCheckboxes.length > 0) {
            button.classList.add("has-subtopics");
          } else {
            button.classList.remove("has-subtopics");
          }
        });
      });
    }
  });
}

// For mobile
const topicAccordions = topicForm?.querySelectorAll(".accordion");
if (topicAccordions) {
  topicAccordions.forEach((accordion) => {
    const checkboxes = accordion.querySelectorAll(
      'input[type="checkbox"]'
    ) as NodeListOf<HTMLInputElement>;
    const button = accordion.querySelector("button[type='submit']");
    if (button) {
      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", (e) => {
          const selectedCheckboxes = accordion.querySelectorAll('input[type="checkbox"]:checked');
          if (selectedCheckboxes.length > 0) {
            button.classList.add("has-subtopics");
          } else {
            button.classList.remove("has-subtopics");
          }
        });
      });
    }
  });
}

